export default __webpack_public_path__ + "static/raj-abdul-karim-b27935ab08265b6d532b6271686b1c62.jpg";